import React from 'react';
import { Star } from 'lucide-react';

const Reviews = ({ reviews }) => {
  const renderStars = (rating) => {
    return [...Array(rating)].map((_, i) => (
      <Star key={i} size={20} fill="#FFC107" stroke="#FFC107" />
    ));
  };

  return (
    <section id="reviews" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2
            className="text-4xl md:text-5xl font-bold text-gray-900 mb-4"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Lo Que Dicen Nuestros Clientes
          </h2>
          <div className="flex items-center justify-center gap-2 mt-6">
            <div className="flex gap-1">
              {renderStars(5)}
            </div>
            <span className="text-xl font-bold text-gray-700">5.0</span>
            <span className="text-gray-500">en Google Reviews</span>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {reviews.map((review) => (
            <div
              key={review.id}
              className="bg-gradient-to-br from-gray-50 to-white p-8 rounded-xl shadow-lg border border-gray-100 hover:shadow-xl transition-shadow duration-300"
            >
              {/* Stars */}
              <div className="flex gap-1 mb-4">
                {renderStars(review.rating)}
              </div>

              {/* Comment */}
              <p className="text-gray-700 leading-relaxed mb-4 italic">
                "{review.comentario}"
              </p>

              {/* Author and Date */}
              <div className="border-t border-gray-200 pt-4">
                <p className="font-bold text-gray-900">{review.nombre}</p>
                <p className="text-sm text-gray-500">{review.fecha}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Overall Stats */}
        <div className="mt-16 grid md:grid-cols-3 gap-8">
          <div className="text-center p-6 bg-[#C1272D]/5 rounded-xl">
            <div className="flex justify-center gap-1 mb-2">
              {renderStars(5)}
            </div>
            <p className="text-2xl font-bold text-[#C1272D]">Comida</p>
            <p className="text-gray-600">Calidad excepcional</p>
          </div>
          <div className="text-center p-6 bg-[#C1272D]/5 rounded-xl">
            <div className="flex justify-center gap-1 mb-2">
              {renderStars(5)}
            </div>
            <p className="text-2xl font-bold text-[#C1272D]">Servicio</p>
            <p className="text-gray-600">Atención impecable</p>
          </div>
          <div className="text-center p-6 bg-[#C1272D]/5 rounded-xl">
            <div className="flex justify-center gap-1 mb-2">
              {renderStars(5)}
            </div>
            <p className="text-2xl font-bold text-[#C1272D]">Ambiente</p>
            <p className="text-gray-600">Cálido y elegante</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Reviews;
